/**
 * Origen (`source`) de los ítems de un itinerario.
 *
 * El backend asigna `source` a cada producto del itinerario:
 *  - 'Web'                  → producto cotizado desde la web.
 *  - 'Web Offline Request'  → producto cotizado a mano por un operador a partir
 *                             de una solicitud offline (ver form-offline).
 *
 * Varios flujos del front (fee global, reserva parcial, sincronización) tratan
 * a los dos orígenes igual. Antes de que existiera el flujo offline, la
 * comparación era literal contra 'Web', lo que dejaba a los ítems offline
 * fuera de acciones que sí correspondían (eliminar, editar, agregar, cancelar).
 *
 * Este módulo centraliza el criterio para no repetir literales sueltos.
 */

/** `source` de los productos cotizados desde la web. */
export const WEB_SOURCE = 'Web';

/** `source` de los productos cotizados desde una solicitud offline. */
export const OFFLINE_SOURCE = 'Web Offline Request';

/**
 * true si el producto es de origen web o de una cotización offline.
 * Son los productos sobre los que el agente opera (eliminar, editar, etc.).
 */
export function isWebSource(source: string | undefined | null): boolean {
  return source === WEB_SOURCE || source === OFFLINE_SOURCE;
}

/** true si el producto proviene de una cotización offline. */
export function isOfflineSource(source: string | undefined | null): boolean {
  return source === OFFLINE_SOURCE;
}
